import { render, staticRenderFns } from "./searchSousuo.vue?vue&type=template&id=20b8e4e8&scoped=true"
import script from "./searchSousuo.vue?vue&type=script&lang=js"
export * from "./searchSousuo.vue?vue&type=script&lang=js"
import style0 from "./searchSousuo.vue?vue&type=style&index=0&id=20b8e4e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b8e4e8",
  null
  
)

export default component.exports